export { default } from './Table';
export type { TableHeading } from './Table';
export { TableHeader } from './TableHeader';
